/* Outnback — SS26. Hero scroll animation, carousels, size picker, sticky buy bar. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Every Outnback section loads this file, so init runs once per section on a
     page. `once` keeps each initialiser idempotent — without it listeners stack
     up and a single arrow click advances the carousel by the number of copies. */
  function once(el, flag, fn) {
    if (el.dataset[flag] === 'true') { return; }
    el.dataset[flag] = 'true';
    fn(el);
  }

  /* ---------- hero scroll-driven wordmark assembly ---------- */
  function initHero(hero) {
    var back = hero.querySelector('[data-onb-hero-back]');
    var out = hero.querySelector('[data-onb-hero-out]');
    var word = hero.querySelector('[data-onb-hero-word]');
    var cta = hero.querySelector('[data-onb-hero-cta]');
    var hint = hero.querySelector('[data-onb-hero-hint]');
    if (reducedMotion || hero.dataset.onbAnimate === 'false') {
      if (back) back.style.transform = 'none';
      if (out) out.style.transform = 'none';
      if (word) word.style.opacity = '1';
      if (cta) cta.style.opacity = '1';
      if (hint) hint.style.opacity = '0';
      return;
    }
    var ticking = false;
    function clamp01(v) { return Math.max(0, Math.min(1, v)); }
    function ease(t) { return 1 - Math.pow(1 - t, 3); }
    function update() {
      ticking = false;
      var rect = hero.getBoundingClientRect();
      var total = hero.offsetHeight - window.innerHeight;
      var p = total > 0 ? clamp01(-rect.top / total) : 1;
      var fly = ease(clamp01(p / 0.5));
      if (back) back.style.transform = 'translate(' + (1 - fly) * 60 + 'vw, ' + -(1 - fly) * 60 + 'vh)';
      if (out) out.style.transform = 'translate(' + -(1 - fly) * 60 + 'vw, ' + (1 - fly) * 60 + 'vh)';
      if (word) word.style.opacity = clamp01((p - 0.5) / 0.2);
      if (cta) {
        var c = clamp01((p - 0.7) / 0.15);
        cta.style.opacity = c;
        cta.style.pointerEvents = c > 0.5 ? 'auto' : 'none';
      }
      if (hint) hint.style.opacity = 1 - clamp01(p / 0.25);
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ---------- simple carousel (gallery + product feature) ----------
     The nav buttons and the counter must live inside the [data-onb-carousel]
     element — that is the scope this looks in. */
  function initCarousel(root) {
    var track = root.querySelector('[data-onb-track]');
    if (!track) return;
    var count = track.children.length;
    if (count < 2) return;
    var index = 0;
    var label = document.querySelector('[data-onb-carousel-label="' + (root.id || '') + '"]') || root.querySelector('[data-onb-label]');
    function go(delta) {
      index = (index + delta + count) % count;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      if (label) label.textContent = (index + 1) + ' / ' + count;
    }
    root.querySelectorAll('[data-onb-prev]').forEach(function (b) { b.addEventListener('click', function () { go(-1); }); });
    root.querySelectorAll('[data-onb-next]').forEach(function (b) { b.addEventListener('click', function () { go(1); }); });
    if (label) label.textContent = '1 / ' + count;
  }

  /* ---------- PDP: size picker + sticky bar + availability line ---------- */
  function initBuy(root) {
    var idInput = root.querySelector('[data-onb-variant-id]');
    var buttons = root.querySelectorAll('[data-onb-size]');
    var addBtns = document.querySelectorAll('[data-onb-add]');
    var stickyBar = document.querySelector('[data-onb-stickybar]');
    var stickySize = document.querySelector('[data-onb-sticky-size]');
    var anchor = root.querySelector('[data-onb-buy-anchor]');
    var availLines = root.querySelectorAll('[data-onb-avail-variant]');
    var availDefault = root.querySelector('[data-onb-avail-default]');
    var addLabel = (addBtns[0] && addBtns[0].dataset.onbLabelAdd) || 'Add to cart';
    var pickLabel = (addBtns[0] && addBtns[0].dataset.onbLabelPick) || 'Pick a size';
    var hasSizes = buttons.length > 0;

    function setState() {
      var chosen = root.querySelector('[data-onb-size][aria-pressed="true"]');
      var ready = !hasSizes || !!chosen;
      addBtns.forEach(function (b) {
        b.textContent = ready ? addLabel : pickLabel;
        b.disabled = !ready;
      });
      if (stickySize) stickySize.textContent = chosen ? ('Size ' + chosen.dataset.onbSize) : 'Pick a size';

      /* availability line: show the chosen variant's line, else the summary */
      var variantId = chosen ? chosen.dataset.onbVariant : ((!hasSizes && idInput && idInput.value) || '');
      var availMatched = false;
      availLines.forEach(function (el) {
        var on = el.getAttribute('data-onb-avail-variant') === variantId;
        el.hidden = !on;
        if (on) { availMatched = true; }
      });
      if (availDefault) { availDefault.hidden = availMatched; }
    }
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('onb-size--soldout')) return;
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        if (idInput) idInput.value = btn.dataset.onbVariant;
        setState();
      });
    });
    setState();

    if (stickyBar && anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          stickyBar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      io.observe(anchor);
    }
  }

  /* ---------- back to top ---------- */
  function initTop(btn) {
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    });
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-onb-hero]').forEach(function (el) { once(el, 'onbInitHero', initHero); });
    scope.querySelectorAll('[data-onb-carousel]').forEach(function (el) { once(el, 'onbInitCarousel', initCarousel); });
    scope.querySelectorAll('[data-onb-buy]').forEach(function (el) { once(el, 'onbInitBuy', initBuy); });
    scope.querySelectorAll('[data-onb-top]').forEach(function (el) { once(el, 'onbInitTop', initTop); });
  }

  initAll(document);

  /* theme editor: a re-rendered section needs initialising again */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) { initAll(e.target); }
  });
})();
